/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const testEventSubscriptionPathParamsSchema = z.object({
    "id": z.string().describe("Event subscription identifier")
    })

export const testEventSubscriptionHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Event subscription owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Subscriber responded 2xx
 */
export const testEventSubscription200Schema = z.object({
    "deliveryId": z.string(),
"status": z.enum(["succeeded", "failed"]),
"responseCode": z.nullable(z.int().min(-9007199254740991).max(9007199254740991)),
"timeTakenMs": z.nullable(z.int().min(-9007199254740991).max(9007199254740991)),
"errorMessage": z.nullable(z.string())
    })

/**
 * @description Event subscription not found
 */
export const testEventSubscription404Schema = z.any()

/**
 * @description Subscriber responded non-2xx or the request failed (timeout, network, SSRF block)
 */
export const testEventSubscription502Schema = z.object({
    "deliveryId": z.string(),
"status": z.enum(["succeeded", "failed"]),
"responseCode": z.nullable(z.int().min(-9007199254740991).max(9007199254740991)),
"timeTakenMs": z.nullable(z.int().min(-9007199254740991).max(9007199254740991)),
"errorMessage": z.nullable(z.string())
    })

export const testEventSubscriptionMutationResponseSchema = z.lazy(() => testEventSubscription200Schema)